import { Box, Stack, Text } from '@podiumhq/design-system';

const WebchatForm = () => (
  <Box background="silver.light" w="273px" borderRadius="24px">
    <Box
      background="blue.base"
      height="40px"
      borderTopLeftRadius="24px"
      borderTopRightRadius="24px"
    />
    <Stack gap={2} padding="16px">
      <Box
        background="silver.base"
        borderRadius="13px"
        p="12px 18px"
        color="black.base"
        textAlign="left"
        fontSize="sm"
        borderBottomLeftRadius="0px"
      >
        Enter your information and our team will text you shortly.
      </Box>
      <Box
        background="white"
        w="241px"
        borderRadius="16px"
        borderBottomRightRadius="0px"
        padding="12px 15px"
        marginTop="0"
      >
        <Text
          color="black.base"
          borderBottom="2px solid #F1F5FB"
          paddingBottom="6px"
          w="85%"
        >
          Tori Jones
        </Text>
        <Text
          color="black.base"
          borderBottom="2px solid #F1F5FB"
          p="10px 0 6px 0px"
          w="85%"
        >
          801-758-0580
        </Text>
        <Text
          color="black.base"
          borderBottom="2px solid #F1F5FB"
          p="10px 0 6px 0px"
          w="85%"
        >
          Hi! I’d like to get a quote.
        </Text>
      </Box>
    </Stack>
  </Box>
);

export default WebchatForm;
